<template>
  <div />
</template>

<script setup>
import { onMounted } from 'vue';
import Swal from 'sweetalert2';

onMounted(() => {
  window.$bus.on('alert-on', data => {
    confirm(data.title, data.question, data.cancelButtonText, data.confirmButtonText);
  });

  window.$bus.on('alert-spc', data => {
    confirmSpc(data.title, data.question, data.cancelButtonText, data.confirmButtonText);
  });

  window.$bus.on('alert-sucess', data => {
    showSuccess(data.title, data.message);
  });

  window.$bus.on('alert-error', data => {
    showError(data.title, data.error, data.confirmButtonText);
  });

  window.$bus.on('alert-warning', data => {
    showWarning(data.title, data.message);
  });

  window.$bus.on('alert-warning-html', data => {
    attentionHtml(data.title, data.message, data.confirmButtonText);
  });
});

const confirm = (title, question, cancelButtonText = 'Não', confirmButtonText = 'Sim') => {
  Swal.fire({
    title: title,
    text: question,
    icon: 'warning',
    confirmButtonText:
      confirmButtonText === undefined || confirmButtonText === '' ? 'Sim' : confirmButtonText,
    cancelButtonText:
      cancelButtonText === undefined || cancelButtonText === '' ? 'Não' : cancelButtonText,
    showCancelButton: true,
    focusConfirm: false,
    focusCancel: true,
    allowOutsideClick: false,
    reverseButtons: true,
  }).then(result => window.$bus.emit('alert-response', result));
};

const confirmSpc = (title, question, cancelButtonText = 'Sim', confirmButtonText = 'Nâo') => {
  Swal.fire({
    title: title,
    text: question,
    icon: 'warning',
    confirmButtonText:
      confirmButtonText === undefined || confirmButtonText === '' ? 'Não' : confirmButtonText,
    cancelButtonText:
      cancelButtonText === undefined || cancelButtonText === '' ? 'Sim' : cancelButtonText,
    showCancelButton: true,
    focusConfirm: true,
    focusCancel: false,
    allowOutsideClick: true,
    reverseButtons: true,
  }).then(result => window.$bus.emit('alert-response', result));
};

const showError = (title, error, confirmButtonText = 'Ok') => {
  Swal.fire({
    title: title,
    text: error,
    icon: 'error',
    allowOutsideClick: false,
    confirmButtonText: confirmButtonText,
  }).then(() => window.$bus.emit('alert-response'));
};

const showSuccess = (title, message) => {
  Swal.fire({
    title: title,
    text: message,
    icon: 'success',
    allowOutsideClick: false,
  }).then(() => window.$bus.emit('alert-response'));
};

const showWarning = (title, message) => {
  Swal.fire({
    title: title,
    text: message,
    icon: 'warning',
    allowOutsideClick: false,
  });
};

const attentionHtml = (title, message, confirmButtonText) => {
  Swal.fire({
    title: title,
    icon: 'warning',
    html: message,
    confirmButtonText:
      confirmButtonText === undefined || confirmButtonText === '' ? 'OK' : confirmButtonText,
  }).then(() => window.$bus.emit('alert-response'));
};

const _openImage = image => {
  Swal.fire({
    imageUrl: image,
    showCloseButton: true,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    background: 'none',
    customClass: 'swal2-custom',
  });
};
</script>
